import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Text,
  StyleSheet,
  Modal,
} from "react-native";
import { useNavigation } from "@react-navigation/native";

import FeedIcons from "../../../assets/Icons/FeedIcons";
import ModalComponent from "../../ModalComponent";
// Define the props interface
interface RejectProfileProps {
  isVisible: boolean;
  toggleModal: () => void;
  from: string;
}

// Functional component
export default function RejectProfile({
  isVisible,
  toggleModal,
  from,
}: RejectProfileProps) {
  const navigation = useNavigation();
  useEffect(() => {
    // Close the modal after 1 second
    if (isVisible) {
      const timerId = setTimeout(() => {
        toggleModal();
        if (from === "feed") {
        } else {
          navigation.navigate("Interests" as never);
        }
      }, 400);

      // Clear the timer if the component unmounts or if the modal is closed before the timer expires
      return () => clearTimeout(timerId);
    }
  }, [isVisible, toggleModal]);
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.modalBackground}>
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <View style={styles.CloseIcon}>
              <FeedIcons.CrossIcon />
            </View>
          </View>
        </View>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  CloseIcon: {
    transform: [{ scale: 1.9 }],
  },
  modalWrap: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 3,
    paddingVertical: 30,
    paddingBottom: 20,
  },
  modalBackground: {
    flex: 1,
    backgroundColor: "white",
  },
  modalContainer: {
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    // top: '30%',
    height: "100%",
    alignItems: "center",
  },
});
